import { useCallback, useState } from 'react'

function useForceUpdate(callback?: () => void) {
  const [dependency, setDependency] = useState(new Date().getTime())

  const update = useCallback(() => {
    setDependency(new Date().getTime())
    if (callback) callback()
  }, [callback])

  return {
    update,
    dependency,
  }
}

export default useForceUpdate
